import React from "react";
import ReactFileViewer from "react-file-viewer";

function FilePreview({ fileUrl }) {
  // Determine the file type based on the file extension
  const fileUrlWithoutParams = fileUrl.split("?")[0];
  const fileExtension = fileUrlWithoutParams.split(".").pop();
  const fileOptions = {
    fileType: fileExtension,
    filePath: fileUrl,
  };

  return (
    <div>
      <ReactFileViewer {...fileOptions} />
    </div>
  );
}

export default FilePreview;
